import {
    mapState,
    mapActions
} from "vuex";


const inscriptionMixin = {
    data: () => ({
        
    }),
    methods: {
        /* funcion para normalizar la tarifa de inscripcion parejas/grupocria */
        mixNormalizarTarifa(tarifa) {
            let result = [];
            tarifa.forEach(t => {
                const {
                    id: tarifa_id,
                    expo_id,
                    name,
                    ini_date,
                    end_date,
                    expo_rate_types
                } = t;
                const incl = {
                    tarifa_id,
                    expo_id,
                    name,
                    ini_date,
                    end_date
                };
                expo_rate_types.forEach(e => {
                    const {
                        id: expo_rate_types_id,
                        rate_id,
                        expo_date_inscription_id,
                        price_type_discount_id,
                        breeds_id,
                        classes_id,
                        countries_id,
                        expo_prices
                    } = e;
                    const incl2 = {
                        expo_rate_types_id,
                        rate_id,
                        expo_date_inscription_id,
                        price_type_discount_id,
                        breeds_id,
                        classes_id,
                        countries_id
                    };
                    expo_prices.forEach(ep => {
                        const {
                            id: expo_prices_id,
                            expo_rate_type_id,
                            price,
                            price_partner,
                            count
                        } = ep;
                        const incl3 = {
                            expo_prices_id,
                            expo_rate_type_id,
                            price,
                            price_partner,
                            count
                        };
                        //insertamos el obj dentro de un array
                        result.push({
                            ...incl,
                            ...incl2,
                            ...incl3
                        });
                    });
                });
            });

            return result;

        },
        mixgenerarTarifaIns(tarifa, razaId, nacionalidad, clase_permitida) {
            const tarifaNormalizada = this.mixNormalizarTarifa(tarifa);
            const raza =  razaId.toString(); 

            const filtro = tarifaNormalizada.filter(tn => {
                if (
                    !!tn.classes_id &&
                    tn.classes_id.split(",").includes(clase_permitida.toString())
                ) {
                    //si hay paises
                    if (!!tn.countries_id) {
                        const natCheck = tn.countries_id
                            .split(",")
                            .includes(nacionalidad.toString()) ?
                            true :
                            false;
                        if (!natCheck) return;
                    }
                    //si hay razas
                    if (!!tn.breeds_id) {
                        const razaCheck = !!tn.breeds_id && tn.countries_id.split(",").includes(raza) ?
                            true :
                            false;
                        if (!razaCheck) return;
                    }
                    //si llegamos es que es valida la tarifa
                    return tn;
                }
            });

            return filtro;
        }
    }

}


export {
    inscriptionMixin
}